export default __webpack_public_path__ + "static/media/featured-in-mobile.78f1872a.svg";